/**
 * custom.js — Turbi store customisations
 */

document.addEventListener('DOMContentLoaded', function () {

  function initVideoPopup(triggerSelector, modalId) {
    var trigger = document.querySelector(triggerSelector);
    var modal   = document.getElementById(modalId);
    if (!trigger || !modal) return;

    var iframe = modal.querySelector('iframe');
    var closeBtn = modal.querySelector('.turbi-popup__close');

    var videoUrl = trigger.getAttribute('href');
    if (videoUrl && iframe) {
      iframe.setAttribute('src', videoUrl);
    }
    trigger.removeAttribute('href');

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closeModal(modal, iframe);
      });
    }

    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        closeModal(modal, iframe);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.style.display === 'flex') {
        closeModal(modal, iframe);
      }
    });
  }

  function closeModal(modal, iframe) {
    modal.style.display = 'none';
    document.body.style.overflow = '';
    if (iframe) {
      var src = iframe.getAttribute('src');
      iframe.setAttribute('src', '');
      iframe.setAttribute('src', src);
    }
  }

  initVideoPopup('.slideshow_first_video',  'popupModalFirst');
  initVideoPopup('.slideshow_second_video', 'popupModalSecond');

});